// composables/useAuth.js
import { useUserStore } from '~/stores/user';

export const useAuth = (supabase, userStore) => {
  const restoreSession = async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    if (session) {
      localStorage.setItem('session', JSON.stringify(session));
      await userStore.fetchUserAndProfile(session);
    } else {
      userStore.user.id = '';
      localStorage.removeItem('session');
    }
  };

  const handleAuthStateChange = async (event, session) => {
    if (event === 'SIGNED_IN') {
      localStorage.setItem('session', JSON.stringify(session));
      await userStore.fetchUserAndProfile(session);
    } else if (event === 'SIGNED_OUT') {
      userStore.user.id = '';
      localStorage.removeItem('session');
    }
  };

  async function continueAsGuest() {
    const userStore = useUserStore();
    const { data, error } = await supabase.auth.signInAnonymously();

    if (error) {
      console.error('Anonymous sign-in failed:', error.message);
      return { error };
    }

    await userStore.fetchUserAndProfile(data.session);

    return { data };
  }

  async function convertGuestToAccount({ email, password, name }) {
    const {
      data: { user },
      error: authError,
    } = await supabase.auth.updateUser({ email, password });
    if (authError) return { error: authError };

    if (name) {
      const { error: profileError } = await supabase
        .from('profiles')
        .update({ name, email })
        .eq('id', user.id);
      if (profileError) return { error: profileError };
    }

    return { data: user };
  }

  async function convertGuestToOAuth(provider) {
    const { data, error } = await supabase.auth.linkIdentity({ provider });
    if (error) return { error };
    return { data };
  }

  function isAnonymousUser(session) {
    return session?.user?.is_anonymous === true;
  }

  return {
    restoreSession,
    handleAuthStateChange,
    continueAsGuest,
    convertGuestToAccount,
    convertGuestToOAuth,
    isAnonymousUser,
  };
};
